import React, {useEffect } from 'react';
import { Router, Route, Switch, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import TagManager from 'react-gtm-module';
import ReactGA from "react-ga4";
import AOS from 'aos'
import { history } from '../_helpers';
import "../assets/vendor/aos/aos.css"
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/glightbox/css/glightbox.min.css";
import "../assets/vendor/swiper/swiper-bundle.min.css";
import "../assets/css/style.css";
import "../assets/css/slide.css";
// import "../assets/vendor/bootstrap/js/bootstrap.bundle.min.js";
// import "../assets/vendor/swiper/swiper-bundle.min.js";
import "../assets/js/main";

import Header from "../Page/Header";
import Footer from "../Page/Footer";
import home from "../Page/home";
import AboutUs from "../Page/AboutUs";
import ContactUs from "../Page/ContactUs";
import Disclaimer from "../Page/Disclaimer";
import Privacy from "../Page/Privacy";
import Terms from "../Page/Terms";
import RefundPolicy from "../Page/RefundPolicy";
import Sitemap from "../Page/Sitemap";
import ThankYou from "../Page/ThankYou";
import TopAirlines from "../Page/CommonDestination/TopAirlines";
import TopDestinations from "../Page/CommonDestination/TopDestinations";
import Deals from "../Page/CommonDestination/Deals";
import GiftCard from "../Page/CommonDestination/GiftCard";


import Hotels from "../Page/Hotels/Hotels";
import Cars from "../Page/Cars/Cars";
import Holidays from "../Page/Holidays/Holidays";
import Cruises from "../Page/Cruises/Cruises";
import Insurance from "../Page/Insurance/Insurance";
import PackageTours from "../Page/PackageTours/PackageTours";
import TrainsBuses from "../Page/TrainsBuses/TrainsBuses";
import TransfersAir from "../Page/TransfersAir/TransfersAir";
import CarBikerentals from "../Page/CarBikerentals/CarBikerentals";

import Accomodation from "../Page/Accomodation/Accomodation";
import Movies from "../Page/Movies/Movies";
import Events from "../Page/Events/Events";
import Sports from "../Page/Sports/Sports";
import FindADriver from "../Page/FindADriver/FindADriver";

               

import AmericanAirlines from "../Page/Airlines/AmericanAirlines";
import UnitedAirlines from "../Page/Airlines/UnitedAirlines";
import JetblueAirways from "../Page/Airlines/JetblueAirways";
import Lufthansa from "../Page/Airlines/Lufthansa";
import TurkishAirlines from "../Page/Airlines/TurkishAirlines";
import UsAirways from "../Page/Airlines/UsAirways";

import CheapFlightsDomesticIndia from "../Page/Flights/CheapFlightsDomesticIndia";
import CheapFlightsToGoa from "../Page/Flights/CheapFlightsToGoa";
import CheapFlightsToDelhi from "../Page/Flights/CheapFlightsToDelhi";
import CheapFlights from "../Page/Flights/CheapFlights";
import CheapFlightsToBali from "../Page/Flights/CheapFlightsToBali";
import CheapFlightsToDubaiDxb from "../Page/Flights/CheapFlightsToDubaiDxb";
import CheapFlightsToLosAngelesLax from "../Page/Flights/CheapFlightsToLosAngelesLax";
import Flights from "../Page/Flights/Flights";
import IndiaToLosAngelesFlights from "../Page/Flights/IndiaToLosAngelesFlights";
import CheapFlightsToVegas from "../Page/Flights/CheapFlightsToVegas";
import CheapFlightsToFlorida from "../Page/Flights/CheapFlightsToFlorida";
import CheapFlightsToMiami from "../Page/Flights/CheapFlightsToMiami";
import CheapFlightsToHawaii from "../Page/Flights/CheapFlightsToHawaii";
import CheapFlightsToOrlando from "../Page/Flights/CheapFlightsToOrlando";
import CheapFlightsToEurope from "../Page/Flights/CheapFlightsToEurope";
import CheapFlightsToNewYork from "../Page/Flights/CheapFlightsToNewYork";
import ScottsCheapFlights from "../Page/Flights/ScottsCheapFlights";
import CheapFlightDeals from "../Page/Flights/CheapFlightDeals";
import CheapTickets from "../Page/Flights/CheapTickets";
import CheapFlightTickets from "../Page/Flights/CheapFlightTickets";
import FlightDeals from "../Page/Flights/FlightDeals";
import LastMinuteFlightDeals from "../Page/Flights/LastMinuteFlightDeals";
import AirlineTickets from "../Page/Flights/AirlineTickets";
import CheapAirlineTickets from "../Page/Flights/CheapAirlineTickets";
import CheapPlaneTickets from "../Page/Flights/CheapPlaneTickets";
import CheapFlightsToPakistan from "../Page/Flights/CheapFlightsToPakistan";
import CheapFlightsToAmsterdam from "../Page/Flights/CheapFlightsToAmsterdam";
import FlightsFromAtlToSlc from "../Page/Flights/FlightsFromAtlToSlc";
import FlightsToJamaicaFromClt from "../Page/Flights/FlightsToJamaicaFromClt";
import LockdownFlights from "../Page/Flights/LockdownFlights";
import FlightsToStt from "../Page/Flights/FlightsToStt";
import FlightsFromSanAntonioToPhiladelphia from "../Page/Flights/FlightsFromSanAntonioToPhiladelphia";
import CheapFlightsFromAmarillo from "../Page/Flights/CheapFlightsFromAmarillo";
import CheapFlightsToKeyLargo from "../Page/Flights/CheapFlightsToKeyLargo";
import CheapFlightsFromBangkokToLondonHeathrowOneWay from "../Page/Flights/CheapFlightsFromBangkokToLondonHeathrowOneWay";
import CheapFlightsToArcataEurekaAcv from "../Page/Flights/CheapFlightsToArcataEurekaAcv";
import CheapFlightsToSantaClaraSnu from "../Page/Flights/CheapFlightsToSantaClaraSnu";
import CheapFlightsToFairbanksFai from "../Page/Flights/CheapFlightsToFairbanksFai";
import CheapFlightsToRapidCityRap from "../Page/Flights/CheapFlightsToRapidCityRap";
import CheapFlightsToJacksonvilleIjx from "../Page/Flights/CheapFlightsToJacksonvilleIjx";
import CheapFlightsToPlattsburghPbg from "../Page/Flights/CheapFlightsToPlattsburghPbg";
import CheapFlightsToKilleenFortHoodIle from "../Page/Flights/CheapFlightsToKilleenFortHoodIle";
import CheapFlightsToLafayetteLft from "../Page/Flights/CheapFlightsToLafayetteLft";
import CheapFlightsToSantaBarbaraSba from "../Page/Flights/CheapFlightsToSantaBarbaraSba";
import CheapFlightsToJacksonvilleOaj from "../Page/Flights/CheapFlightsToJacksonvilleOaj";
import CheapFlightsToHiloIto from "../Page/Flights/CheapFlightsToHiloIto";
import CheapFlightsToSouthBendSbn from "../Page/Flights/CheapFlightsToSouthBendSbn";
import CheapFlightsToStLouisXls from "../Page/Flights/CheapFlightsToStLouisXls";
import CheapFlightsToNewportNewsWilliamsburgPhf from "../Page/Flights/CheapFlightsToNewportNewsWilliamsburgPhf";
import CheapFlightsToPascoPsc from "../Page/Flights/CheapFlightsToPascoPsc";
import CheapFlightsToGainesvilleGnv from "../Page/Flights/CheapFlightsToGainesvilleGnv";
import CheapFlightsToGreenBayGrb from "../Page/Flights/CheapFlightsToGreenBayGrb";
import CheapFlightsToRoanokeRoa from "../Page/Flights/CheapFlightsToRoanokeRoa";
import CheapFlightsFromHoustonToColorado from "../Page/Flights/CheapFlightsFromHoustonToColorado";
import CheapFlightsToAngkorWat from "../Page/Flights/CheapFlightsToAngkorWat";
import CheapFlightsToMontrealFromToronto from "../Page/Flights/CheapFlightsToMontrealFromToronto";
import CheapFlightsToStSimonsIsland from "../Page/Flights/CheapFlightsToStSimonsIsland";
import CheapFlightsFromRennesToGlasgow from "../Page/Flights/CheapFlightsFromRennesToGlasgow";
import MumbaiToItalyCheapFlights from "../Page/Flights/MumbaiToItalyCheapFlights";
import BaliToTokyoCheapFlights from "../Page/Flights/BaliToTokyoCheapFlights";
import BangaloreToBaliCheapFlights from "../Page/Flights/BangaloreToBaliCheapFlights";
import CheapFlightsToLilleFrance from "../Page/Flights/CheapFlightsToLilleFrance";
import CheapFlightsToLeonMx from "../Page/Flights/CheapFlightsToLeonMx";
import CheapFlightToTaiwanFromMalaysia from "../Page/Flights/CheapFlightToTaiwanFromMalaysia";
import CheapFlightsToIsraelFromToronto from "../Page/Flights/CheapFlightsToIsraelFromToronto";
import CheapFlightsToMexicoFromCanada from "../Page/Flights/CheapFlightsToMexicoFromCanada";
import CheapFlightsToUsaFromSouthAfrica from "../Page/Flights/CheapFlightsToUsaFromSouthAfrica";
import HyderabadToSrinagarCheapFlights from "../Page/Flights/HyderabadToSrinagarCheapFlights";
import MaaToCcuCheapFlight from "../Page/Flights/MaaToCcuCheapFlight";
import MaaToYyzCheapFlights from "../Page/Flights/MaaToYyzCheapFlights";
import ManilaToElNidoCheapFlights from "../Page/Flights/ManilaToElNidoCheapFlights";
import CheapFlightsToMartinique from "../Page/Flights/CheapFlightsToMartinique";
import BostonToOrlandoFlights from "../Page/Flights/BostonToOrlandoFlights";
import CheapFlightsToAbileneAbi from "../Page/Flights/CheapFlightsToAbileneAbi";
import CheapFlightsToAkronCantonCak from "../Page/Flights/CheapFlightsToAkronCantonCak";
import CheapFlightsToAlamosaAls from "../Page/Flights/CheapFlightsToAlamosaAls";
import CheapFlightsToAlbanyAlb from "../Page/Flights/CheapFlightsToAlbanyAlb";
import CheapFlightsToAlbuquerqueAbq from "../Page/Flights/CheapFlightsToAlbuquerqueAbq";
import CheapFlightsToAlexandriaAex from "../Page/Flights/CheapFlightsToAlexandriaAex";
import CheapFlightsToAltoonaAoo from "../Page/Flights/CheapFlightsToAltoonaAoo";
import CheapFlightsToAmarilloAma from "../Page/Flights/CheapFlightsToAmarilloAma";
import CheapFlightsToAnchorageAnc from "../Page/Flights/CheapFlightsToAnchorageAnc";
import CheapFlightsToAppletonAtw from "../Page/Flights/CheapFlightsToAppletonAtw";
import CheapFlightsToAspenAse from "../Page/Flights/CheapFlightsToAspenAse";
import CheapFlightsToAtlantaAtl from "../Page/Flights/CheapFlightsToAtlantaAtl";
import CheapFlightsToAtlanticCityAcy from "../Page/Flights/CheapFlightsToAtlanticCityAcy";
import CheapFlightsToAustinAus from "../Page/Flights/CheapFlightsToAustinAus";
import CheapFlightsToBakersfieldBfl from "../Page/Flights/CheapFlightsToBakersfieldBfl";
import CheapFlightsToBaltimoreBwi from "../Page/Flights/CheapFlightsToBaltimoreBwi";
import CheapFlightsToBatonRougeBtr from "../Page/Flights/CheapFlightsToBatonRougeBtr";
import CheapFlightsToBellinghamBli from "../Page/Flights/CheapFlightsToBellinghamBli";
import CheapFlightsToBinghamtonBgm from "../Page/Flights/CheapFlightsToBinghamtonBgm";
import CheapFlightsToBismarckBis from "../Page/Flights/CheapFlightsToBismarckBis";
import CheapFlightsToBoiseBoi from "../Page/Flights/CheapFlightsToBoiseBoi";
import CheapFlightsToBostonBos from "../Page/Flights/CheapFlightsToBostonBos";
import CheapFlightsToBradfordBfd from "../Page/Flights/CheapFlightsToBradfordBfd";
import CheapFlightsToBrownsvilleBro from "../Page/Flights/CheapFlightsToBrownsvilleBro";
import CheapFlightsToBuffaloBuf from "../Page/Flights/CheapFlightsToBuffaloBuf";
import CheapFlightsToBurbankBur from "../Page/Flights/CheapFlightsToBurbankBur";
import CheapFlightsToBurlingtonBtv from "../Page/Flights/CheapFlightsToBurlingtonBtv";
import CheapFlightsToCapeGirardeauCgi from "../Page/Flights/CheapFlightsToCapeGirardeauCgi";
import CheapFlightsToChampaignUrbanaCmi from "../Page/Flights/CheapFlightsToChampaignUrbanaCmi";
import CheapFlightsToCharlestonChs from "../Page/Flights/CheapFlightsToCharlestonChs";
import CheapFlightsToCharlotteClt from "../Page/Flights/CheapFlightsToCharlotteClt";
import CheapFlightsToChattanoogaCha from "../Page/Flights/CheapFlightsToChattanoogaCha";
import CheapFlightsToChicagoChi from "../Page/Flights/CheapFlightsToChicagoChi";
import CheapFlightsToCincinnatiCvg from "../Page/Flights/CheapFlightsToCincinnatiCvg";
import CheapFlightsToClevelandCle from "../Page/Flights/CheapFlightsToClevelandCle";
import CheapFlightsToColoradoSpringsCos from "../Page/Flights/CheapFlightsToColoradoSpringsCos";
import CheapFlightsToColumbusCmh from "../Page/Flights/CheapFlightsToColumbusCmh";
import CheapFlightsToDallasDfw from "../Page/Flights/CheapFlightsToDallasDfw";
import CheapFlightsToDaytonaBeachDab from "../Page/Flights/CheapFlightsToDaytonaBeachDab";
import CheapFlightsToDecaturDec from "../Page/Flights/CheapFlightsToDecaturDec";
import CheapFlightsToDenverDen from "../Page/Flights/CheapFlightsToDenverDen";
import CheapFlightsToDesMoinesDsm from "../Page/Flights/CheapFlightsToDesMoinesDsm";
import CheapFlightsToDetroitDtt from "../Page/Flights/CheapFlightsToDetroitDtt";
import CheapFlightsToElPasoElp from "../Page/Flights/CheapFlightsToElPasoElp";
import CheapFlightsToEugeneEug from "../Page/Flights/CheapFlightsToEugeneEug";
import CheapFlightsToFargoFar from "../Page/Flights/CheapFlightsToFargoFar";
import CheapFlightsToFarmingtonFmn from "../Page/Flights/CheapFlightsToFarmingtonFmn";
import CheapFlightsToFlintFnt from "../Page/Flights/CheapFlightsToFlintFnt";
import CheapFlightsToFortLauderdaleFll from "../Page/Flights/CheapFlightsToFortLauderdaleFll";
import CheapFlightsToFortMyersFmy from "../Page/Flights/CheapFlightsToFortMyersFmy";
import CheapFlightsToFortWayneFwa from "../Page/Flights/CheapFlightsToFortWayneFwa";
import CheapFlightsToFresnoFat from "../Page/Flights/CheapFlightsToFresnoFat";
import CheapFlightsToGrandCanyonGcn from "../Page/Flights/CheapFlightsToGrandCanyonGcn";
import CheapFlightsToGrandRapidsGrr from "../Page/Flights/CheapFlightsToGrandRapidsGrr";
import CheapFlightsToHartfordHfd from "../Page/Flights/CheapFlightsToHartfordHfd";
import CheapFlightsToHonoluluHnl from "../Page/Flights/CheapFlightsToHonoluluHnl";
import CheapFlightsToHoustonHou from "../Page/Flights/CheapFlightsToHoustonHou";
import CheapFlightsToIndianapolisInd from "../Page/Flights/CheapFlightsToIndianapolisInd";
import CheapFlightsToIslipIsp from "../Page/Flights/CheapFlightsToIslipIsp";
import CheapFlightsToJacksonvilleJax from "../Page/Flights/CheapFlightsToJacksonvilleJax";
import CheapFlightsToKansasCityMci from "../Page/Flights/CheapFlightsToKansasCityMci";
import CheapFlightsToKonaKoa from "../Page/Flights/CheapFlightsToKonaKoa";
import CheapFlightsToLasVegasLas from "../Page/Flights/CheapFlightsToLasVegasLas";
import CheapFlightsToLatrobeLbe from "../Page/Flights/CheapFlightsToLatrobeLbe";
import CheapFlightsToLongBeachLgb from "../Page/Flights/CheapFlightsToLongBeachLgb";
import CheapFlightsToLouisvilleSdf from "../Page/Flights/CheapFlightsToLouisvilleSdf";
import CheapFlightsToMcallenMissionMfe from "../Page/Flights/CheapFlightsToMcallenMissionMfe";
import CheapFlightsToMemphisMem from "../Page/Flights/CheapFlightsToMemphisMem";
import CheapFlightsToMiamiMia from "../Page/Flights/CheapFlightsToMiamiMia";
import CheapFlightsToMilwaukeeMke from "../Page/Flights/CheapFlightsToMilwaukeeMke";
import CheapFlightsToMinneapolisMsp from "../Page/Flights/CheapFlightsToMinneapolisMsp";
import CheapFlightsToMissoulaMso from "../Page/Flights/CheapFlightsToMissoulaMso";
import CheapFlightsToMorristownMmu from "../Page/Flights/CheapFlightsToMorristownMmu";
import CheapFlightsToMyrtleBeachMyr from "../Page/Flights/CheapFlightsToMyrtleBeachMyr";
import CheapFlightsToNashvilleBna from "../Page/Flights/CheapFlightsToNashvilleBna";
import CheapFlightsToNewOrleansMsy from "../Page/Flights/CheapFlightsToNewOrleansMsy";
import CheapFlightsToNewYorkNyc from "../Page/Flights/CheapFlightsToNewYorkNyc";
import CheapFlightsToNiagaraFallsIag from "../Page/Flights/CheapFlightsToNiagaraFallsIag";
import CheapFlightsToNorfolkOrf from "../Page/Flights/CheapFlightsToNorfolkOrf";
import CheapFlightsToOaklandOak from "../Page/Flights/CheapFlightsToOaklandOak";
import CheapFlightsToOklahomaCityOkc from "../Page/Flights/CheapFlightsToOklahomaCityOkc";
import CheapFlightsToOmahaOma from "../Page/Flights/CheapFlightsToOmahaOma";
import CheapFlightsToOntarioOnt from "../Page/Flights/CheapFlightsToOntarioOnt";
import CheapFlightsToOrlandoOrl from "../Page/Flights/CheapFlightsToOrlandoOrl";
import CheapFlightsToPalmSpringsPsp from "../Page/Flights/CheapFlightsToPalmSpringsPsp";
import CheapFlightsToPensacolaPns from "../Page/Flights/CheapFlightsToPensacolaPns";
import CheapFlightsToPhiladelphiaPhl from "../Page/Flights/CheapFlightsToPhiladelphiaPhl";
import CheapFlightsToPhoenixPhx from "../Page/Flights/CheapFlightsToPhoenixPhx";
import CheapFlightsToPittsburghPit from "../Page/Flights/CheapFlightsToPittsburghPit";
import CheapFlightsToPortlandPdx from "../Page/Flights/CheapFlightsToPortlandPdx";
import CheapFlightsToProvidencePvd from "../Page/Flights/CheapFlightsToProvidencePvd";
import CheapFlightsToRaleighDurhamRdu from "../Page/Flights/CheapFlightsToRaleighDurhamRdu";
import CheapFlightsToRichmondRic from "../Page/Flights/CheapFlightsToRichmondRic";
import CheapFlightsToSacramentoSac from "../Page/Flights/CheapFlightsToSacramentoSac";
import CheapFlightsToSaltLakeCitySlc from "../Page/Flights/CheapFlightsToSaltLakeCitySlc";
import CheapFlightsToSanAntonioSat from "../Page/Flights/CheapFlightsToSanAntonioSat";
import CheapFlightsToSanDiegoSan from "../Page/Flights/CheapFlightsToSanDiegoSan";
import CheapFlightsToSanFranciscoSfo from "../Page/Flights/CheapFlightsToSanFranciscoSfo";
import CheapFlightsToSanJoseSjc from "../Page/Flights/CheapFlightsToSanJoseSjc";
import CheapFlightsToSantaAnaSna from "../Page/Flights/CheapFlightsToSantaAnaSna";
import CheapFlightsToSeattleSea from "../Page/Flights/CheapFlightsToSeattleSea";
import CheapFlightsToShreveportShv from "../Page/Flights/CheapFlightsToShreveportShv";
import CheapFlightsToSpokaneGeg from "../Page/Flights/CheapFlightsToSpokaneGeg";
import CheapFlightsToStLouisStl from "../Page/Flights/CheapFlightsToStLouisStl";
import CheapFlightsToTampaTpa from "../Page/Flights/CheapFlightsToTampaTpa";
import CheapFlightsToTulsaTul from "../Page/Flights/CheapFlightsToTulsaTul";
import CheapFlightsToValdezVdz from "../Page/Flights/CheapFlightsToValdezVdz";
import CheapFlightsToWashingtonWas from "../Page/Flights/CheapFlightsToWashingtonWas";
import CheapFlightsToWestPalmBeachPbi from "../Page/Flights/CheapFlightsToWestPalmBeachPbi";
import CheapFlightsToRenoRno from "../Page/Flights/CheapFlightsToRenoRno";
import CheapFlightsToNewarkEwr from "../Page/Flights/CheapFlightsToNewarkEwr";
import CheapFlightsToTrentonYtr from "../Page/Flights/CheapFlightsToTrentonYtr";
import CheapFlightsToCasperCpr from "../Page/Flights/CheapFlightsToCasperCpr";
import CheapFlightsToDillinghamDlg from "../Page/Flights/CheapFlightsToDillinghamDlg";
import CheapFlightsToCorpusChristiCrp from "../Page/Flights/CheapFlightsToCorpusChristiCrp";
import CheapFlightsToYumaYum from "../Page/Flights/CheapFlightsToYumaYum";
import CheapFlightsToErieEri from "../Page/Flights/CheapFlightsToErieEri";
import CheapFlightsToCollegeStationCll from "../Page/Flights/CheapFlightsToCollegeStationCll";
import CheapFlightsToLexingtonLex from "../Page/Flights/CheapFlightsToLexingtonLex";
import CheapFlightsToColumbiaCae from "../Page/Flights/CheapFlightsToColumbiaCae";
import CheapFlightsToNoatakWtk from "../Page/Flights/CheapFlightsToNoatakWtk";
import CheapFlightsToBangorBgr from "../Page/Flights/CheapFlightsToBangorBgr";
import CheapFlightsToSedonaSdx from "../Page/Flights/CheapFlightsToSedonaSdx";
import CheapFlightsToWhitePlainsHpn from "../Page/Flights/CheapFlightsToWhitePlainsHpn";
import CheapFlightsToWilmingtonIlg from "../Page/Flights/CheapFlightsToWilmingtonIlg";
import CheapFlightsToFayettevilleFay from "../Page/Flights/CheapFlightsToFayettevilleFay";
import CheapFlightsToDaytonDay from "../Page/Flights/CheapFlightsToDaytonDay";
import CheapFlightsToCheyenneCys from "../Page/Flights/CheapFlightsToCheyenneCys";
import CheapFlightsToWolfPointOlf from "../Page/Flights/CheapFlightsToWolfPointOlf";
import CheapFlightsToBarHarborBhb from "../Page/Flights/CheapFlightsToBarHarborBhb";
import CheapFlightsToSarasotaBradentonSrq from "../Page/Flights/CheapFlightsToSarasotaBradentonSrq";
import CheapFlightsToKahuluiOgg from "../Page/Flights/CheapFlightsToKahuluiOgg";
import CheapFlightsToTucsonTus from "../Page/Flights/CheapFlightsToTucsonTus";
import CheapFlightsToPanamaCityEcp from "../Page/Flights/CheapFlightsToPanamaCityEcp";
import CheapFlightsToSavannahSav from "../Page/Flights/CheapFlightsToSavannahSav";
import CheapFlightsToKeyWestEyw from "../Page/Flights/CheapFlightsToKeyWestEyw";
import CheapFlightsToDestinFtWaltonBeachVps from "../Page/Flights/CheapFlightsToDestinFtWaltonBeachVps";
import CheapFlightsToSyracuseSyr from "../Page/Flights/CheapFlightsToSyracuseSyr";
import CheapFlightsToGreenvilleSpartanburgGsp from "../Page/Flights/CheapFlightsToGreenvilleSpartanburgGsp";
import CheapFlightsToGreensboroHighPointGso from "../Page/Flights/CheapFlightsToGreensboroHighPointGso";
import CheapFlightsToKnoxvilleTys from "../Page/Flights/CheapFlightsToKnoxvilleTys";
import CheapFlightsToLittleRockLit from "../Page/Flights/CheapFlightsToLittleRockLit";
import CheapFlightsToLihueLih from "../Page/Flights/CheapFlightsToLihueLih";
import CheapFlightsToHarlingenHrl from "../Page/Flights/CheapFlightsToHarlingenHrl";
import CheapFlightsToStPetersburgSpg from "../Page/Flights/CheapFlightsToStPetersburgSpg";
import CheapFlightsToPanamaCityPty from "../Page/Flights/CheapFlightsToPanamaCityPty";
import CheapFlightsToPortlandPwm from "../Page/Flights/CheapFlightsToPortlandPwm";
import CheapFlightsToRochesterRoc from "../Page/Flights/CheapFlightsToRochesterRoc";
import CheapFlightsToAshevilleAvl from "../Page/Flights/CheapFlightsToAshevilleAvl";
import CheapFlightsToJacksonJan from "../Page/Flights/CheapFlightsToJacksonJan";
import CheapFlightsToWichitaIct from "../Page/Flights/CheapFlightsToWichitaIct";
import CheapFlightsToPuntaGordaPnd from "../Page/Flights/CheapFlightsToPuntaGordaPnd";
import CheapFlightsToHarrisburgHar from "../Page/Flights/CheapFlightsToHarrisburgHar";
import CheapFlightsToSpringfieldSgf from "../Page/Flights/CheapFlightsToSpringfieldSgf";
import CheapFlightsToBillingsBil from "../Page/Flights/CheapFlightsToBillingsBil";
import CheapFlightsToBozemanBzn from "../Page/Flights/CheapFlightsToBozemanBzn";
import CheapFlightsToGulfportGpt from "../Page/Flights/CheapFlightsToGulfportGpt";
import CheapFlightsToWilmingtonIlm from "../Page/Flights/CheapFlightsToWilmingtonIlm";
import CheapFlightsToMidlandMaf from "../Page/Flights/CheapFlightsToMidlandMaf";
import CheapFlightsToTallahasseeTlh from "../Page/Flights/CheapFlightsToTallahasseeTlh";
import CheapFlightsToFortWorthFtw from "../Page/Flights/CheapFlightsToFortWorthFtw";
import CheapFlightsToAllentownBthlehmAbe from "../Page/Flights/CheapFlightsToAllentownBthlehmAbe";
import CheapFlightsToMadisonMsn from "../Page/Flights/CheapFlightsToMadisonMsn";
import CheapFlightsToSiouxFallsFsd from "../Page/Flights/CheapFlightsToSiouxFallsFsd";
import CheapFlightsToMobileMob from "../Page/Flights/CheapFlightsToMobileMob";
import CheapFlightsToLubbockLbb from "../Page/Flights/CheapFlightsToLubbockLbb";
import CheapFlightsToSantaFeSaf from "../Page/Flights/CheapFlightsToSantaFeSaf";
import CheapFlightsToMedfordMfr from "../Page/Flights/CheapFlightsToMedfordMfr";
import CheapFlightsToJacksonJac from "../Page/Flights/CheapFlightsToJacksonJac";
import CheapFlightsToCedarRapidsCid from "../Page/Flights/CheapFlightsToCedarRapidsCid";


import CheapHotelsInMohania from "../Page/Hotels/CheapHotelsInMohania";
import CheapHotelsInVaranasi from "../Page/Hotels/CheapHotelsInVaranasi";
import CheapHotelsInAmargarh from "../Page/Hotels/CheapHotelsInAmargarh";
import CheapHotelsInChantarpur from "../Page/Hotels/CheapHotelsInChantarpur";
import CheapHotelsInGaya from "../Page/Hotels/CheapHotelsInGaya";
import CheapHotelsInDeogarh from "../Page/Hotels/CheapHotelsInDeogarh";
import CheapHotelsInAriyalur from "../Page/Hotels/CheapHotelsInAriyalur";
import CheapHotelsInChennai from "../Page/Hotels/CheapHotelsInChennai";
import CheapHotelsInCoimbatore from "../Page/Hotels/CheapHotelsInCoimbatore";
import CheapHotelsInCuddalore from "../Page/Hotels/CheapHotelsInCuddalore";
import CheapHotelsInDharmapuri from "../Page/Hotels/CheapHotelsInDharmapuri";
import CheapHotelsInDindigul from "../Page/Hotels/CheapHotelsInDindigul";
import CheapHotelsInErode from "../Page/Hotels/CheapHotelsInErode";
import CheapHotelsInKanchipuram from "../Page/Hotels/CheapHotelsInKanchipuram";
import CheapHotelsInKanniyakumari from "../Page/Hotels/CheapHotelsInKanniyakumari";
import CheapHotelsInKarur from "../Page/Hotels/CheapHotelsInKarur";
import CheapHotelsInKrishnagiri from "../Page/Hotels/CheapHotelsInKrishnagiri";
import CheapHotelsInMadurai from "../Page/Hotels/CheapHotelsInMadurai";
import CheapHotelsInNagapattinam from "../Page/Hotels/CheapHotelsInNagapattinam";
import CheapHotelsInNamakkal from "../Page/Hotels/CheapHotelsInNamakkal";


import FestivalTravelAndTours from "../Page/Deals/FestivalTravelAndTours";
import FamilyTravelOffers from "../Page/Deals/FamilyTravelOffers";
import HappyNewYear from "../Page/Deals/HappyNewYear";
import OneWayFlights from "../Page/Deals/OneWayFlights";
import FirstClassDeals from "../Page/Deals/FirstClassDeals";
import StudentTravelOffers from "../Page/Deals/StudentTravelOffers";
import CyberMondayFlightsDeals from "../Page/Deals/CyberMondayFlightsDeals";
import DomesticFlightsDeals from "../Page/Deals/DomesticFlightsDeals";
import FlightTickets from "../Page/Deals/FlightTickets";
import LastMinuteFlights from "../Page/Deals/LastMinuteFlights";
import MilitaryTravelDeals from "../Page/Deals/MilitaryTravelDeals";
import ColumbusDayTravel from "../Page/Deals/ColumbusDayTravel";
import MardiGrasFlightDeals from "../Page/Deals/MardiGrasFlightDeals";
import BlackFridayFlightsDeals from "../Page/Deals/BlackFridayFlightsDeals";
import GayLesbianTravel from "../Page/Deals/GayLesbianTravel";
import SpaTravel from "../Page/Deals/SpaTravel";
import UnaccompaniedMinorFlights from "../Page/Deals/UnaccompaniedMinorFlights";
import GolfTravel from "../Page/Deals/GolfTravel";
import WeddingTravel from "../Page/Deals/WeddingTravel";
import HalloweenTravelDeals from "../Page/Deals/HalloweenTravelDeals";
import VeteransDayTravelDeals from "../Page/Deals/VeteransDayTravelDeals";
import ThanksgivingFlightDeals from "../Page/Deals/ThanksgivingFlightDeals";
import ChristmasTravelDeals from "../Page/Deals/ChristmasTravelDeals";
import IndependenceDayDeals from "../Page/Deals/IndependenceDayDeals";
import BusinessClassDeals from "../Page/Deals/BusinessClassDeals";
import GroupTravelDeals from "../Page/Deals/GroupTravelDeals";
import CheapFlightsPrices from "../Page/Deals/CheapFlightsPrices";
import SeniorTravelDealsOffers from "../Page/Deals/SeniorTravelDealsOffers";
import IndependenceDayFlightDeals from "../Page/Deals/IndependenceDayFlightDeals";
import MartinLutherKingDayDeals from "../Page/Deals/MartinLutherKingDayDeals";
import ValentinesDayDeals from "../Page/Deals/ValentinesDayDeals";
import PresidentsDayDeals from "../Page/Deals/PresidentsDayDeals";
import StPatricksDayDeals from "../Page/Deals/StPatricksDayDeals";
import AprilFoolsDayDeals from "../Page/Deals/AprilFoolsDayDeals";
import GoodFridayDeals from "../Page/Deals/GoodFridayDeals";
import EasterTravelDeals from "../Page/Deals/EasterTravelDeals";
import MothersDayFlightDeals from "../Page/Deals/MothersDayFlightDeals";
import MemorialDayFlightDeals from "../Page/Deals/MemorialDayFlightDeals";
import FathersDayTravelDeals from "../Page/Deals/FathersDayTravelDeals";
import LaborDayFlightDeals from "../Page/Deals/LaborDayFlightDeals";
import WinterTravelDeals from "../Page/Deals/WinterTravelDeals";
import DealsUnder$99 from "../Page/Deals/DealsUnder$99";
import HolidayTravelDeals from "../Page/Deals/HolidayTravelDeals";
import RomanticTravelDeals from "../Page/Deals/RomanticTravelDeals";
import IcelandTravelDeals from "../Page/Deals/IcelandTravelDeals";
import CarnivalSaturdayFlightsDeals from "../Page/Deals/CarnivalSaturdayFlightsDeals";
import DealsUnder$199 from "../Page/Deals/DealsUnder$199";
import InternationalFlightsDeals from "../Page/Deals/InternationalFlightsDeals";
import RoundTripFlights from "../Page/Deals/RoundTripFlights";
import TopAirlinesDeals from "../Page/Deals/TopAirlinesDeals";
import LastMinuteTravel from "../Page/Deals/LastMinuteTravel";
import HoneymoonTravel from "../Page/Deals/HoneymoonTravel";
import YogaMediationRetreats from "../Page/Deals/YogaMediationRetreats";
import KidsTravel from "../Page/Deals/KidsTravel";
import BookNowPayLaterFlights from "../Page/Deals/BookNowPayLaterFlights";
import BoxingDayDeals from "../Page/Deals/BoxingDayDeals";
import SpringBreakDeals from "../Page/Deals/SpringBreakDeals";
import SportsTravel from "../Page/Deals/SportsTravel";
import RedEyeFlights from "../Page/Deals/RedEyeFlights";
import MountainTravel from "../Page/Deals/MountainTravel";
import WorldTravel from "../Page/Deals/WorldTravel";
import NatureWildlifeTravel from "../Page/Deals/NatureWildlifeTravel";
import NonStopFlights from "../Page/Deals/NonStopFlights";
import NightlifeTravel from "../Page/Deals/NightlifeTravel";
import SameDayFlights from "../Page/Deals/SameDayFlights";
import SeasonalTravel from "../Page/Deals/SeasonalTravel";
import BereavementFares from "../Page/Deals/BereavementFares";
import SafariTravel from "../Page/Deals/SafariTravel";
import WeekendGetaway from "../Page/Deals/WeekendGetaway";
import ThemeParkTravel from "../Page/Deals/ThemeParkTravel";
import SkiTravel from "../Page/Deals/SkiTravel";


const serviceData = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Cheap Flights Prices - Flight & Hotel Booking Service",
  "image": "https://cheapflightsprices.com/assets/img/logo.png",
  "url": "https://cheapflightsprices.com",
  "description": "Book cheap flight and hotel tickets across India and abroad with Cheap Flights Prices. Lowest airfare guaranteed and exclusive deals on travel bookings.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "U59, DLF Phase 3",
    "addressLocality": "Gurgaon",
    "postalCode": "122002",
    "addressCountry": "IN"
  },
  "sameAs": [
    "https://www.facebook.com/Cheapflightsprices",
    "https://twitter.com/prices_cheap",
    "https://www.instagram.com/Cheapflightsprices",
    "https://in.pinterest.com/Cheapflightsprices",
    "https://www.linkedin.com/company/cheap-flights-prices"
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "email": "cheapflightsprices@gmail.com",
      "contactType": "customer support",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    {
      "@type": "ContactPoint",
      "email": "info@cheapflightsprices.com",
      "contactType": "sales",
      "areaServed": "IN",
      "availableLanguage": ["English"]
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "India"
  },
  "priceRange": "$50 - $1200",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "reviewCount": "2050"
  },
  "mainEntityOfPage": [
    "https://cheapflightsprices.com/flights",
    "https://cheapflightsprices.com/hotels",
    "https://cheapflightsprices.com/contact",
    "https://cheapflightsprices.com/deals"
  ]
};

const productData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Flight and Hotel Booking Services",
  "description": "Book cheap domestic and international flights, and hotels at discounted rates with Cheap Flights Prices. Trusted by thousands of travelers.",
  "image": "https://cheapflightsprices.com/assets/img/banner-main.webp",
  "url": "https://cheapflightsprices.com",
  "brand": {
    "@type": "Brand",
    "name": "Cheap Flights Prices"
  },
  "sku": "CFP-TRAVEL-001",
  "mainEntityOfPage": "https://cheapflightsprices.com",
  "additionalType": "https://schema.org/WebPage",
  "offers": {
    "@type": "AggregateOffer",
    "url": "https://cheapflightsprices.com",
    "priceCurrency": "USD",
    "lowPrice": "50",
    "highPrice": "1200",
    "offerCount": "50000",
    "availability": "https://schema.org/InStock",
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "reviewCount": "1740"
  },
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Verified Customer"
    }
  },
  "keywords": "cheap flight tickets, flight booking india, hotel booking deals, budget travel, book flight online, lowest airfare, cheap international flights",
  "sameAs": [
    "https://www.facebook.com/Cheapflightsprices",
    "https://twitter.com/prices_cheap",
    "https://www.instagram.com/Cheapflightsprices",
    "https://in.pinterest.com/Cheapflightsprices",
    "https://www.linkedin.com/company/cheap-flights-prices"
  ]
};


function App() {

const tagManagerArgs = {
    gtmId: 'GTM-MKHX9NQK'
}
TagManager.initialize(tagManagerArgs)

const TRACKING_ID = "G-CZY53LRPS4";
ReactGA.initialize(TRACKING_ID);
ReactGA.send({ hitType: "pageview", page: "/", title: "Cheap Flights Prices" });



	 useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
    return (
        <div>
 
                    <Router history={history}>
                 <Header />
        <Helmet>     
  <meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="theme-color" content="#fff" />
<meta name="google-site-verification" content="v1NPNyoW9kqW8_e8pf1FrUJSlfjVKw0tdsA4cs6gJ-8" />
<meta name="author" content="cheapflightsprices.com" />
  </Helmet>
                        <Switch>
                            <Route exact path= {["/","/home", "/index.html"]} component={home} />
                            <Route path="/about-us.html" component={AboutUs} />
                            <Route path="/terms-and-conditions.html" component={Terms} />
                            <Route path="/privacy-policy.html" component={Privacy} />
                            <Route path="/disclaimer.html" component={Disclaimer} />
                            <Route path="/refund-cancellation-policy.html" component={RefundPolicy} />
                            <Route path="/site-map.html" component={Sitemap} />
                            <Route path="/contact-us.html" component={ContactUs} />
                            <Route path="/hotels.html" component={Hotels} />
                            <Route path="/cars.html" component={Cars} />
                            <Route path="/holidays.html" component={Holidays} />
                            <Route path="/cruises.html" component={Cruises} />
                            <Route path="/insurance" component={Insurance} />
                            <Route path="/tours-package" component={PackageTours} />
                            <Route path="/trains-buses" component={TrainsBuses} />
                            <Route path="/air-transfers" component={TransfersAir} />
                            <Route path="/car-bike-rentals" component={CarBikerentals} />
                            <Route path="/accomodation" component={Accomodation} />
                            <Route path="/movies" component={Movies} />
                            <Route path="/events" component={Events} />
                            <Route path="/sports" component={Sports} />
                            <Route path="/find-a-driver" component={FindADriver} />
                            <Route path="/top-airlines" component={TopAirlines} />
                            <Route path="/top-destinations" component={TopDestinations} />
                            <Route path="/deals" component={Deals} />
                            <Route path="/gift-card" component={GiftCard} />
                            <Route path="/thank-you" component={ThankYou} />
                 


<Route path="/airlines/american-airlines.html" component={AmericanAirlines} />
<Route path="/airlines/jetblue-airways.html" component={JetblueAirways} />
<Route path="/airlines/lufthansa.html" component={Lufthansa} />
<Route path="/airlines/united-airlines.html" component={UnitedAirlines} />
<Route path="/airlines/turkish-airlines.html" component={TurkishAirlines} />
<Route path="/airlines/us-airways.html" component={UsAirways} />
<Route path="/flights/cheap-flights-domestic-india.html" component={CheapFlightsDomesticIndia} />
<Route path="/flights/cheap-flights-to-goa.html" component={CheapFlightsToGoa} />
<Route path="/flights/cheap-flights-to-delhi.html" component={CheapFlightsToDelhi} />
<Route path="/flights/cheap-flights.html" component={CheapFlights} />
<Route path="/flights/cheap-flights-to-bali.html" component={CheapFlightsToBali} />
<Route path="/flights/cheap-flights-to-dubai-dxb.html" component={CheapFlightsToDubaiDxb} />
<Route path="/flights/cheap-flights-to-los-angeles-lax.html" component={CheapFlightsToLosAngelesLax} />
<Route path="/flights.html" component={Flights} />
<Route path="/flights/india-to-los-angeles-flights.html" component={IndiaToLosAngelesFlights} />
<Route path="/flights/cheap-flights-to-vegas.html" component={CheapFlightsToVegas} />
<Route path="/flights/cheap-flights-to-florida.html" component={CheapFlightsToFlorida} />
<Route path="/flights/cheap-flights-to-miami.html" component={CheapFlightsToMiami} />
<Route path="/flights/cheap-flights-to-hawaii.html" component={CheapFlightsToHawaii} />
<Route path="/flights/cheap-flights-to-orlando.html" component={CheapFlightsToOrlando} />
<Route path="/flights/cheap-flights-to-europe.html" component={CheapFlightsToEurope} />
<Route path="/flights/cheap-flights-to-new-york.html" component={CheapFlightsToNewYork} />
<Route path="/flights/scott's-cheap-flights.html" component={ScottsCheapFlights} />
<Route path="/flights/cheap-flight-deals.html" component={CheapFlightDeals} />
<Route path="/flights/cheap-tickets.html" component={CheapTickets} />
<Route path="/flights/cheap-flight-tickets.html" component={CheapFlightTickets} />
<Route path="/flights/flight-deals.html" component={FlightDeals} />
<Route path="/flights/last-minute-flight-deals.html" component={LastMinuteFlightDeals} />
<Route path="/flights/airline-tickets.html" component={AirlineTickets} />
<Route path="/flights/cheap-airline-tickets.html" component={CheapAirlineTickets} />
<Route path="/flights/cheap-plane-tickets.html" component={CheapPlaneTickets} />
<Route path="/flights/cheap-flights-to-pakistan.html" component={CheapFlightsToPakistan} />
<Route path="/flights/cheap-flights-to-amsterdam.html" component={CheapFlightsToAmsterdam} />
<Route path="/flights/flights-from-atl-to-slc.html" component={FlightsFromAtlToSlc} />
<Route path="/flights/flights-to-jamaica-from-clt.html" component={FlightsToJamaicaFromClt} />
<Route path="/flights/lockdown-flights.html" component={LockdownFlights} />
<Route path="/flights/flights-to-stt.html" component={FlightsToStt} />
<Route path="/flights/flights-from-san-antonio-to-philadelphia.html" component={FlightsFromSanAntonioToPhiladelphia} />
<Route path="/flights/cheap-flights-from-amarillo.html" component={CheapFlightsFromAmarillo} />
<Route path="/flights/cheap-flights-to-key-largo.html" component={CheapFlightsToKeyLargo} />
<Route path="/flights/cheap-flights-from-bangkok-to-london-heathrow-one-way.html" component={CheapFlightsFromBangkokToLondonHeathrowOneWay} />
<Route path="/flights/cheap-flights-to-arcata-eureka-acv.html" component={CheapFlightsToArcataEurekaAcv} />
<Route path="/flights/cheap-flights-to-santa-clara-snu.html" component={CheapFlightsToSantaClaraSnu} />
<Route path="/flights/cheap-flights-to-fairbanks-fai.html" component={CheapFlightsToFairbanksFai} />
<Route path="/flights/cheap-flights-to-rapid-city-rap.html" component={CheapFlightsToRapidCityRap} />
<Route path="/flights/cheap-flights-to-jacksonville-ijx.html" component={CheapFlightsToJacksonvilleIjx} />
<Route path="/flights/cheap-flights-to-plattsburgh-pbg.html" component={CheapFlightsToPlattsburghPbg} />
<Route path="/flights/cheap-flights-to-killeen-fort-hood-ile.html" component={CheapFlightsToKilleenFortHoodIle} />
<Route path="/flights/cheap-flights-to-lafayette-lft.html" component={CheapFlightsToLafayetteLft} />
<Route path="/flights/cheap-flights-to-santa-barbara-sba.html" component={CheapFlightsToSantaBarbaraSba} />
<Route path="/flights/cheap-flights-to-jacksonville-oaj.html" component={CheapFlightsToJacksonvilleOaj} />
<Route path="/flights/cheap-flights-to-hilo-ito.html" component={CheapFlightsToHiloIto} />
<Route path="/flights/cheap-flights-to-south-bend-sbn.html" component={CheapFlightsToSouthBendSbn} />
<Route path="/flights/cheap-flights-to-st-louis-xls.html" component={CheapFlightsToStLouisXls} />
<Route path="/flights/cheap-flights-to-newport-news-williamsburg-phf.html" component={CheapFlightsToNewportNewsWilliamsburgPhf} />
<Route path="/flights/cheap-flights-to-pasco-psc.html" component={CheapFlightsToPascoPsc} />
<Route path="/flights/cheap-flights-to-gainesville-gnv.html" component={CheapFlightsToGainesvilleGnv} />
<Route path="/flights/cheap-flights-to-green-bay-grb.html" component={CheapFlightsToGreenBayGrb} />
<Route path="/flights/cheap-flights-to-roanoke-roa.html" component={CheapFlightsToRoanokeRoa} />
<Route path="/flights/cheap-flights-from-houston-to-colorado.html" component={CheapFlightsFromHoustonToColorado} />
<Route path="/flights/cheap-flights-to-angkor-wat.html" component={CheapFlightsToAngkorWat} />
<Route path="/flights/cheap-flights-to-montreal-from-toronto.html" component={CheapFlightsToMontrealFromToronto} />
<Route path="/flights/cheap-flights-to-st-simons-island.html" component={CheapFlightsToStSimonsIsland} />
<Route path="/flights/cheap-flights-from-rennes-to-glasgow.html" component={CheapFlightsFromRennesToGlasgow} />
<Route path="/flights/mumbai-to-italy-cheap-flights.html" component={MumbaiToItalyCheapFlights} />
<Route path="/flights/bali-to-tokyo-cheap-flights.html" component={BaliToTokyoCheapFlights} />
<Route path="/flights/bangalore-to-bali-cheap-flights.html" component={BangaloreToBaliCheapFlights} />
<Route path="/flights/cheap-flights-to-lille-france.html" component={CheapFlightsToLilleFrance} />
<Route path="/flights/cheap-flights-to-leon-mx.html" component={CheapFlightsToLeonMx} />
<Route path="/flights/cheap-flights-to-israel-from-toronto.html" component={CheapFlightsToIsraelFromToronto} />
<Route path="/flights/cheap-flights-to-mexico-from-canada.html" component={CheapFlightsToMexicoFromCanada} />
<Route path="/flights/cheap-flights-to-usa-from-south-africa.html" component={CheapFlightsToUsaFromSouthAfrica} />
<Route path="/flights/hyderabad-to-srinagar-cheap-flights.html" component={HyderabadToSrinagarCheapFlights} />
<Route path="/flights/maa-to-ccu-cheap-flight.html" component={MaaToCcuCheapFlight} />
<Route path="/flights/maa-to-yyz-cheap-flights.html" component={MaaToYyzCheapFlights} />
<Route path="/flights/manila-to-el-nido-cheap-flights.html" component={ManilaToElNidoCheapFlights} />
<Route path="/flights/cheap-flights-to-martinique.html" component={CheapFlightsToMartinique} />
<Route path="/flights/boston-to-orlando-flights.html" component={BostonToOrlandoFlights} />
<Route path="/flights/cheap-flights-to-abilene-abi.html" component={CheapFlightsToAbileneAbi} />
<Route path="/flights/cheap-flights-to-akron-canton-cak.html" component={CheapFlightsToAkronCantonCak} />
<Route path="/flights/cheap-flights-to-alamosa-als.html" component={CheapFlightsToAlamosaAls} />
<Route path="/flights/cheap-flights-to-albany-alb.html" component={CheapFlightsToAlbanyAlb} />
<Route path="/flights/cheap-flights-to-albuquerque-abq.html" component={CheapFlightsToAlbuquerqueAbq} />
<Route path="/flights/cheap-flights-to-alexandria-aex.html" component={CheapFlightsToAlexandriaAex} />
<Route path="/flights/cheap-flights-to-altoona-aoo.html" component={CheapFlightsToAltoonaAoo} />
<Route path="/flights/cheap-flights-to-amarillo-ama.html" component={CheapFlightsToAmarilloAma} />
<Route path="/flights/cheap-flights-to-anchorage-anc.html" component={CheapFlightsToAnchorageAnc} />
<Route path="/flights/cheap-flights-to-appleton-atw.html" component={CheapFlightsToAppletonAtw} />
<Route path="/flights/cheap-flights-to-aspen-ase.html" component={CheapFlightsToAspenAse} />
<Route path="/flights/cheap-flights-to-atlanta-atl.html" component={CheapFlightsToAtlantaAtl} />
<Route path="/flights/cheap-flights-to-atlantic-city-acy.html" component={CheapFlightsToAtlanticCityAcy} />
<Route path="/flights/cheap-flights-to-austin-aus.html" component={CheapFlightsToAustinAus} />
<Route path="/flights/cheap-flights-to-bakersfield-bfl.html" component={CheapFlightsToBakersfieldBfl} />
<Route path="/flights/cheap-flights-to-baltimore-bwi.html" component={CheapFlightsToBaltimoreBwi} />
<Route path="/flights/cheap-flights-to-baton-rouge-btr.html" component={CheapFlightsToBatonRougeBtr} />
<Route path="/flights/cheap-flights-to-bellingham-bli.html" component={CheapFlightsToBellinghamBli} />
<Route path="/flights/cheap-flights-to-binghamton-bgm.html" component={CheapFlightsToBinghamtonBgm} />
<Route path="/flights/cheap-flights-to-bismarck-bis.html" component={CheapFlightsToBismarckBis} />
<Route path="/flights/cheap-flights-to-boise-boi.html" component={CheapFlightsToBoiseBoi} />
<Route path="/flights/cheap-flights-to-boston-bos.html" component={CheapFlightsToBostonBos} />
<Route path="/flights/cheap-flights-to-bradford-bfd.html" component={CheapFlightsToBradfordBfd} />
<Route path="/flights/cheap-flights-to-brownsville-bro.html" component={CheapFlightsToBrownsvilleBro} />
<Route path="/flights/cheap-flights-to-buffalo-buf.html" component={CheapFlightsToBuffaloBuf} />
<Route path="/flights/cheap-flights-to-burbank-bur.html" component={CheapFlightsToBurbankBur} />
<Route path="/flights/cheap-flights-to-burlington-btv.html" component={CheapFlightsToBurlingtonBtv} />
<Route path="/flights/cheap-flights-to-cape-girardeau-cgi.html" component={CheapFlightsToCapeGirardeauCgi} />
<Route path="/flights/cheap-flights-to-champaign-urbana-cmi.html" component={CheapFlightsToChampaignUrbanaCmi} />
<Route path="/flights/cheap-flights-to-charleston-chs.html" component={CheapFlightsToCharlestonChs} />
<Route path="/flights/cheap-flights-to-charlotte-clt.html" component={CheapFlightsToCharlotteClt} />
<Route path="/flights/cheap-flights-to-chattanooga-cha.html" component={CheapFlightsToChattanoogaCha} />
<Route path="/flights/cheap-flights-to-chicago-chi.html" component={CheapFlightsToChicagoChi} />
<Route path="/flights/cheap-flights-to-cincinnati-cvg.html" component={CheapFlightsToCincinnatiCvg} />
<Route path="/flights/cheap-flights-to-cleveland-cle.html" component={CheapFlightsToClevelandCle} />
<Route path="/flights/cheap-flights-to-colorado-springs-cos.html" component={CheapFlightsToColoradoSpringsCos} />
<Route path="/flights/cheap-flights-to-columbus-cmh.html" component={CheapFlightsToColumbusCmh} />
<Route path="/flights/cheap-flights-to-dallas-dfw.html" component={CheapFlightsToDallasDfw} />
<Route path="/flights/cheap-flights-to-daytona-beach-dab.html" component={CheapFlightsToDaytonaBeachDab} />
<Route path="/flights/cheap-flights-to-decatur-dec.html" component={CheapFlightsToDecaturDec} />
<Route path="/flights/cheap-flights-to-denver-den.html" component={CheapFlightsToDenverDen} />
<Route path="/flights/cheap-flights-to-des-moines-dsm.html" component={CheapFlightsToDesMoinesDsm} />
<Route path="/flights/cheap-flights-to-detroit-dtt.html" component={CheapFlightsToDetroitDtt} />
<Route path="/flights/cheap-flights-to-el-paso-elp.html" component={CheapFlightsToElPasoElp} />
<Route path="/flights/cheap-flights-to-eugene-eug.html" component={CheapFlightsToEugeneEug} />
<Route path="/flights/cheap-flights-to-fargo-far.html" component={CheapFlightsToFargoFar} />
<Route path="/flights/cheap-flights-to-farmington-fmn.html" component={CheapFlightsToFarmingtonFmn} />
<Route path="/flights/cheap-flights-to-flint-fnt.html" component={CheapFlightsToFlintFnt} />
<Route path="/flights/cheap-flights-to-fort-lauderdale-fll.html" component={CheapFlightsToFortLauderdaleFll} />
<Route path="/flights/cheap-flights-to-fort-myers-fmy.html" component={CheapFlightsToFortMyersFmy} />
<Route path="/flights/cheap-flights-to-fort-wayne-fwa.html" component={CheapFlightsToFortWayneFwa} />
<Route path="/flights/cheap-flights-to-fresno-fat.html" component={CheapFlightsToFresnoFat} />
<Route path="/flights/cheap-flights-to-grand-canyon-gcn.html" component={CheapFlightsToGrandCanyonGcn} />
<Route path="/flights/cheap-flights-to-grand-rapids-grr.html" component={CheapFlightsToGrandRapidsGrr} />
<Route path="/flights/cheap-flights-to-hartford-hfd.html" component={CheapFlightsToHartfordHfd} />
<Route path="/flights/cheap-flights-to-honolulu-hnl.html" component={CheapFlightsToHonoluluHnl} />
<Route path="/flights/cheap-flights-to-houston-hou.html" component={CheapFlightsToHoustonHou} />
<Route path="/flights/cheap-flights-to-indianapolis-ind.html" component={CheapFlightsToIndianapolisInd} />
<Route path="/flights/cheap-flights-to-islip-isp.html" component={CheapFlightsToIslipIsp} />
<Route path="/flights/cheap-flights-to-jacksonville-jax.html" component={CheapFlightsToJacksonvilleJax} />
<Route path="/flights/cheap-flights-to-kansas-city-mci.html" component={CheapFlightsToKansasCityMci} />
<Route path="/flights/cheap-flights-to-kona-koa.html" component={CheapFlightsToKonaKoa} />
<Route path="/flights/cheap-flights-to-las-vegas-las.html" component={CheapFlightsToLasVegasLas} />
<Route path="/flights/cheap-flights-to-latrobe-lbe.html" component={CheapFlightsToLatrobeLbe} />
<Route path="/flights/cheap-flights-to-long-beach-lgb.html" component={CheapFlightsToLongBeachLgb} />
<Route path="/flights/cheap-flights-to-louisville-sdf.html" component={CheapFlightsToLouisvilleSdf} />
<Route path="/flights/cheap-flights-to-mcallen-mission-mfe.html" component={CheapFlightsToMcallenMissionMfe} />
<Route path="/flights/cheap-flights-to-memphis-mem.html" component={CheapFlightsToMemphisMem} />
<Route path="/flights/cheap-flights-to-miami-mia.html" component={CheapFlightsToMiamiMia} />
<Route path="/flights/cheap-flights-to-milwaukee-mke.html" component={CheapFlightsToMilwaukeeMke} />
<Route path="/flights/cheap-flights-to-minneapolis-msp.html" component={CheapFlightsToMinneapolisMsp} />
<Route path="/flights/cheap-flights-to-missoula-mso.html" component={CheapFlightsToMissoulaMso} />
<Route path="/flights/cheap-flights-to-morristown-mmu.html" component={CheapFlightsToMorristownMmu} />
<Route path="/flights/cheap-flights-to-myrtle-beach-myr.html" component={CheapFlightsToMyrtleBeachMyr} />
<Route path="/flights/cheap-flights-to-nashville-bna.html" component={CheapFlightsToNashvilleBna} />
<Route path="/flights/cheap-flights-to-new-orleans-msy.html" component={CheapFlightsToNewOrleansMsy} />
<Route path="/flights/cheap-flights-to-new-york-nyc.html" component={CheapFlightsToNewYorkNyc} />
<Route path="/flights/cheap-flights-to-niagara-falls-iag.html" component={CheapFlightsToNiagaraFallsIag} />
<Route path="/flights/cheap-flights-to-norfolk-orf.html" component={CheapFlightsToNorfolkOrf} />
<Route path="/flights/cheap-flights-to-oakland-oak.html" component={CheapFlightsToOaklandOak} />
<Route path="/flights/cheap-flights-to-oklahoma-city-okc.html" component={CheapFlightsToOklahomaCityOkc} />
<Route path="/flights/cheap-flights-to-omaha-oma.html" component={CheapFlightsToOmahaOma} />
<Route path="/flights/cheap-flights-to-ontario-ont.html" component={CheapFlightsToOntarioOnt} />
<Route path="/flights/cheap-flights-to-orlando-orl.html" component={CheapFlightsToOrlandoOrl} />
<Route path="/flights/cheap-flights-to-palm-springs-psp.html" component={CheapFlightsToPalmSpringsPsp} />
<Route path="/flights/cheap-flights-to-pensacola-pns.html" component={CheapFlightsToPensacolaPns} />
<Route path="/flights/cheap-flights-to-philadelphia-phl.html" component={CheapFlightsToPhiladelphiaPhl} />
<Route path="/flights/cheap-flights-to-phoenix-phx.html" component={CheapFlightsToPhoenixPhx} />
<Route path="/flights/cheap-flights-to-pittsburgh-pit.html" component={CheapFlightsToPittsburghPit} />
<Route path="/flights/cheap-flights-to-portland-pdx.html" component={CheapFlightsToPortlandPdx} />
<Route path="/flights/cheap-flights-to-providence-pvd.html" component={CheapFlightsToProvidencePvd} />
<Route path="/flights/cheap-flights-to-raleigh-durham-rdu.html" component={CheapFlightsToRaleighDurhamRdu} />
<Route path="/flights/cheap-flights-to-richmond-ric.html" component={CheapFlightsToRichmondRic} />
<Route path="/flights/cheap-flights-to-sacramento-sac.html" component={CheapFlightsToSacramentoSac} />
<Route path="/flights/cheap-flights-to-salt-lake-city-slc.html" component={CheapFlightsToSaltLakeCitySlc} />
<Route path="/flights/cheap-flights-to-san-antonio-sat.html" component={CheapFlightsToSanAntonioSat} />
<Route path="/flights/cheap-flights-to-san-diego-san.html" component={CheapFlightsToSanDiegoSan} />
<Route path="/flights/cheap-flights-to-san-francisco-sfo.html" component={CheapFlightsToSanFranciscoSfo} />
<Route path="/flights/cheap-flights-to-san-jose-sjc.html" component={CheapFlightsToSanJoseSjc} />
<Route path="/flights/cheap-flights-to-santa-ana-sna.html" component={CheapFlightsToSantaAnaSna} />
<Route path="/flights/cheap-flights-to-seattle-sea.html" component={CheapFlightsToSeattleSea} />
<Route path="/flights/cheap-flights-to-shreveport-shv.html" component={CheapFlightsToShreveportShv} />
<Route path="/flights/cheap-flights-to-spokane-geg.html" component={CheapFlightsToSpokaneGeg} />
<Route path="/flights/cheap-flights-to-st-louis-stl.html" component={CheapFlightsToStLouisStl} />
<Route path="/flights/cheap-flights-to-tampa-tpa.html" component={CheapFlightsToTampaTpa} />
<Route path="/flights/cheap-flights-to-tulsa-tul.html" component={CheapFlightsToTulsaTul} />
<Route path="/flights/cheap-flights-to-valdez-vdz.html" component={CheapFlightsToValdezVdz} />
<Route path="/flights/cheap-flights-to-washington-was.html" component={CheapFlightsToWashingtonWas} />
<Route path="/flights/cheap-flights-to-west-palm-beach-pbi.html" component={CheapFlightsToWestPalmBeachPbi} />
<Route path="/flights/cheap-flights-to-reno-rno.html" component={CheapFlightsToRenoRno} />
<Route path="/flights/cheap-flights-to-newark-ewr.html" component={CheapFlightsToNewarkEwr} />
<Route path="/flights/cheap-flights-to-trenton-ytr.html" component={CheapFlightsToTrentonYtr} />
<Route path="/flights/cheap-flights-to-casper-cpr.html" component={CheapFlightsToCasperCpr} />
<Route path="/flights/cheap-flights-to-dillingham-dlg.html" component={CheapFlightsToDillinghamDlg} />
<Route path="/flights/cheap-flights-to-corpus-christi-crp.html" component={CheapFlightsToCorpusChristiCrp} />
<Route path="/flights/cheap-flights-to-yuma-yum.html" component={CheapFlightsToYumaYum} />
<Route path="/flights/cheap-flights-to-erie-eri.html" component={CheapFlightsToErieEri} />
<Route path="/flights/cheap-flights-to-college-station-cll.html" component={CheapFlightsToCollegeStationCll} />
<Route path="/flights/cheap-flights-to-lexington-lex.html" component={CheapFlightsToLexingtonLex} />
<Route path="/flights/cheap-flights-to-columbia-cae.html" component={CheapFlightsToColumbiaCae} />
<Route path="/flights/cheap-flights-to-noatak-wtk.html" component={CheapFlightsToNoatakWtk} />
<Route path="/flights/cheap-flights-to-bangor-bgr.html" component={CheapFlightsToBangorBgr} />
<Route path="/flights/cheap-flights-to-sedona-sdx.html" component={CheapFlightsToSedonaSdx} />
<Route path="/flights/cheap-flights-to-white-plains-hpn.html" component={CheapFlightsToWhitePlainsHpn} />
<Route path="/flights/cheap-flights-to-wilmington-ilg.html" component={CheapFlightsToWilmingtonIlg} />
<Route path="/flights/cheap-flights-to-fayetteville-fay.html" component={CheapFlightsToFayettevilleFay} />
<Route path="/flights/cheap-flights-to-dayton-day.html" component={CheapFlightsToDaytonDay} />
<Route path="/flights/cheap-flights-to-cheyenne-cys.html" component={CheapFlightsToCheyenneCys} />
<Route path="/flights/cheap-flights-to-wolf-point-olf.html" component={CheapFlightsToWolfPointOlf} />
<Route path="/flights/cheap-flights-to-bar-harbor-bhb.html" component={CheapFlightsToBarHarborBhb} />
<Route path="/flights/cheap-flights-to-sarasota-bradenton-srq.html" component={CheapFlightsToSarasotaBradentonSrq} />
<Route path="/flights/cheap-flights-to-kahului-ogg.html" component={CheapFlightsToKahuluiOgg} />
<Route path="/flights/cheap-flights-to-tucson-tus.html" component={CheapFlightsToTucsonTus} />
<Route path="/flights/cheap-flights-to-panama-city-ecp.html" component={CheapFlightsToPanamaCityEcp} />
<Route path="/flights/cheap-flights-to-savannah-sav.html" component={CheapFlightsToSavannahSav} />
<Route path="/flights/cheap-flights-to-key-west-eyw.html" component={CheapFlightsToKeyWestEyw} />
<Route path="/flights/cheap-flights-to-destin-ft-walton-beach-vps.html" component={CheapFlightsToDestinFtWaltonBeachVps} />
<Route path="/flights/cheap-flights-to-syracuse-syr.html" component={CheapFlightsToSyracuseSyr} />
<Route path="/flights/cheap-flights-to-greenville-spartanburg-gsp.html" component={CheapFlightsToGreenvilleSpartanburgGsp} />
<Route path="/flights/cheap-flights-to-greensboro-high-point-gso.html" component={CheapFlightsToGreensboroHighPointGso} />
<Route path="/flights/cheap-flights-to-knoxville-tys.html" component={CheapFlightsToKnoxvilleTys} />
<Route path="/flights/cheap-flights-to-little-rock-lit.html" component={CheapFlightsToLittleRockLit} />
<Route path="/flights/cheap-flights-to-lihue-lih.html" component={CheapFlightsToLihueLih} />
<Route path="/flights/cheap-flights-to-harlingen-hrl.html" component={CheapFlightsToHarlingenHrl} />
<Route path="/flights/cheap-flights-to-st-petersburg-spg.html" component={CheapFlightsToStPetersburgSpg} />
<Route path="/flights/cheap-flights-to-panama-city-pty.html" component={CheapFlightsToPanamaCityPty} />
<Route path="/flights/cheap-flights-to-portland-pwm.html" component={CheapFlightsToPortlandPwm} />
<Route path="/flights/cheap-flights-to-rochester-roc.html" component={CheapFlightsToRochesterRoc} />
<Route path="/flights/cheap-flights-to-asheville-avl.html" component={CheapFlightsToAshevilleAvl} />
<Route path="/flights/cheap-flights-to-jackson-jan.html" component={CheapFlightsToJacksonJan} />
<Route path="/flights/cheap-flights-to-wichita-ict.html" component={CheapFlightsToWichitaIct} />
<Route path="/flights/cheap-flights-to-punta-gorda-pnd.html" component={CheapFlightsToPuntaGordaPnd} />
<Route path="/flights/cheap-flights-to-harrisburg-har.html" component={CheapFlightsToHarrisburgHar} />
<Route path="/flights/cheap-flights-to-springfield-sgf.html" component={CheapFlightsToSpringfieldSgf} />
<Route path="/flights/cheap-flights-to-billings-bil.html" component={CheapFlightsToBillingsBil} />
<Route path="/flights/cheap-flights-to-bozeman-bzn.html" component={CheapFlightsToBozemanBzn} />
<Route path="/flights/cheap-flights-to-gulfport-gpt.html" component={CheapFlightsToGulfportGpt} />
<Route path="/flights/cheap-flights-to-wilmington-ilm.html" component={CheapFlightsToWilmingtonIlm} />
<Route path="/flights/cheap-flights-to-midland-maf.html" component={CheapFlightsToMidlandMaf} />
<Route path="/flights/cheap-flights-to-tallahassee-tlh.html" component={CheapFlightsToTallahasseeTlh} />
<Route path="/flights/cheap-flights-to-fort-worth-ftw.html" component={CheapFlightsToFortWorthFtw} />
<Route path="/flights/cheap-flights-to-allentown-bthlehm-abe.html" component={CheapFlightsToAllentownBthlehmAbe} />
<Route path="/flights/cheap-flights-to-madison-msn.html" component={CheapFlightsToMadisonMsn} />
<Route path="/flights/cheap-flights-to-sioux-falls-fsd.html" component={CheapFlightsToSiouxFallsFsd} />
<Route path="/flights/cheap-flights-to-mobile-mob.html" component={CheapFlightsToMobileMob} />
<Route path="/flights/cheap-flights-to-lubbock-lbb.html" component={CheapFlightsToLubbockLbb} />
<Route path="/flights/cheap-flights-to-santa-fe-saf.html" component={CheapFlightsToSantaFeSaf} />
<Route path="/flights/cheap-flights-to-medford-mfr.html" component={CheapFlightsToMedfordMfr} />
<Route path="/flights/cheap-flights-to-jackson-jac.html" component={CheapFlightsToJacksonJac} />
<Route path="/flights/cheap-flights-to-cedar-rapids-cid.html" component={CheapFlightsToCedarRapidsCid} />
<Route path="/flights/cheap-flights-to-taiwan-from-malaysia.html" component={CheapFlightToTaiwanFromMalaysia} />


<Route path="/hotels/cheap-hotels-in-mohania.html" component={CheapHotelsInMohania} />
<Route path="/hotels/cheap-hotels-in-varanasi.html" component={CheapHotelsInVaranasi} />
<Route path="/hotels/cheap-hotels-in-amargarh.html" component={CheapHotelsInAmargarh} />
<Route path="/hotels/cheap-hotels-in-chantarpur.html" component={CheapHotelsInChantarpur} />
<Route path="/hotels/cheap-hotels-in-gaya.html" component={CheapHotelsInGaya} />
<Route path="/hotels/cheap-hotels-in-deogarh.html" component={CheapHotelsInDeogarh} />
<Route path="/hotels/cheap-hotels-in-ariyalur.html" component={CheapHotelsInAriyalur} />
<Route path="/hotels/cheap-hotels-in-chennai.html" component={CheapHotelsInChennai} />
<Route path="/hotels/cheap-hotels-in-coimbatore.html" component={CheapHotelsInCoimbatore} />
<Route path="/hotels/cheap-hotels-in-cuddalore.html" component={CheapHotelsInCuddalore} />
<Route path="/hotels/cheap-hotels-in-dharmapuri.html" component={CheapHotelsInDharmapuri} />
<Route path="/hotels/cheap-hotels-in-dindigul.html" component={CheapHotelsInDindigul} />
<Route path="/hotels/cheap-hotels-in-erode.html" component={CheapHotelsInErode} />
<Route path="/hotels/cheap-hotels-in-kanchipuram.html" component={CheapHotelsInKanchipuram} />
<Route path="/hotels/cheap-hotels-in-kanniyakumari.html" component={CheapHotelsInKanniyakumari} />
<Route path="/hotels/cheap-hotels-in-karur.html" component={CheapHotelsInKarur} />
<Route path="/hotels/cheap-hotels-in-krishnagiri.html" component={CheapHotelsInKrishnagiri} />
<Route path="/hotels/cheap-hotels-in-madurai.html" component={CheapHotelsInMadurai} />
<Route path="/hotels/cheap-hotels-in-nagapattinam.html" component={CheapHotelsInNagapattinam} />
<Route path="/hotels/cheap-hotels-in-namakkal.html" component={CheapHotelsInNamakkal} />



<Route path="/deals/festival-travel-and-tours.html" component={FestivalTravelAndTours} />
<Route path="/deals/family-travel-offers.html" component={FamilyTravelOffers} />
<Route path="/deals/happy-new-year.html" component={HappyNewYear} />
<Route path="/deals/one-way-flights.html" component={OneWayFlights} />
<Route path="/deals/first-class-deals.html" component={FirstClassDeals} />
<Route path="/deals/student-travel-offers.html" component={StudentTravelOffers} />
<Route path="/deals/cyber-monday-flights-deals.html" component={CyberMondayFlightsDeals} />
<Route path="/deals/domestic-flights-deals.html" component={DomesticFlightsDeals} />
<Route path="/deals/flight-tickets.html" component={FlightTickets} />
<Route path="/deals/last-minute-flights.html" component={LastMinuteFlights} />
<Route path="/deals/military-travel-deals.html" component={MilitaryTravelDeals} />
<Route path="/deals/columbus-day-travel.html" component={ColumbusDayTravel} />
<Route path="/deals/mardi-gras-flight-deals.html" component={MardiGrasFlightDeals} />
<Route path="/deals/black-friday-flights-deals.html" component={BlackFridayFlightsDeals} />
<Route path="/deals/gay-lesbian-travel.html" component={GayLesbianTravel} />
<Route path="/deals/spa-travel.html" component={SpaTravel} />
<Route path="/deals/unaccompanied-minor-flights.html" component={UnaccompaniedMinorFlights} />
<Route path="/deals/golf-travel.html" component={GolfTravel} />
<Route path="/deals/wedding-travel.html" component={WeddingTravel} />
<Route path="/deals/halloween-travel-deals.html" component={HalloweenTravelDeals} />
<Route path="/deals/veterans-day-travel-deals.html" component={VeteransDayTravelDeals} />
<Route path="/deals/thanksgiving-flight-deals.html" component={ThanksgivingFlightDeals} />
<Route path="/deals/christmas-travel-deals.html" component={ChristmasTravelDeals} />
<Route path="/deals/independence-day-deals.html" component={IndependenceDayDeals} />
<Route path="/deals/business-class-deals.html" component={BusinessClassDeals} />
<Route path="/deals/group-travel-deals.html" component={GroupTravelDeals} />
<Route path="/deals/cheap-flights-prices.html" component={CheapFlightsPrices} />
<Route path="/deals/senior-travel-deals-offers.html" component={SeniorTravelDealsOffers} />
<Route path="/deals/independence-day-flight-deals.html" component={IndependenceDayFlightDeals} />
<Route path="/deals/martin-luther-king-day-deals.html" component={MartinLutherKingDayDeals} />
<Route path="/deals/valentines-day-deals.html" component={ValentinesDayDeals} />
<Route path="/deals/presidents-day-deals.html" component={PresidentsDayDeals} />
<Route path="/deals/st-patricks-day-deals.html" component={StPatricksDayDeals} />
<Route path="/deals/april-fools-day-deals.html" component={AprilFoolsDayDeals} />
<Route path="/deals/good-friday-deals.html" component={GoodFridayDeals} />
<Route path="/deals/easter-travel-deals.html" component={EasterTravelDeals} />
<Route path="/deals/mothers-day-flight-deals.html" component={MothersDayFlightDeals} />
<Route path="/deals/memorial-day-flight-deals.html" component={MemorialDayFlightDeals} />
<Route path="/deals/fathers-day-Travel-deals.html" component={FathersDayTravelDeals} />
<Route path="/deals/labor-day-flight-deals.html" component={LaborDayFlightDeals} />
<Route path="/deals/winter-travel-deals.html" component={WinterTravelDeals} />
<Route path="/deals/deals-under-$99.html" component={DealsUnder$99} />
<Route path="/deals/holiday-travel-deals.html" component={HolidayTravelDeals} />
<Route path="/deals/romantic-travel-deals.html" component={RomanticTravelDeals} />
<Route path="/deals/iceland-travel-deals.html" component={IcelandTravelDeals} />
<Route path="/deals/carnival-saturday-flights-deals.html" component={CarnivalSaturdayFlightsDeals} />
<Route path="/deals/deals-under-$199.html" component={DealsUnder$199} />
<Route path="/deals/international-flights-deals.html" component={InternationalFlightsDeals} />
<Route path="/deals/round-trip-flights.html" component={RoundTripFlights} />
<Route path="/deals/top-airlines-deals.html" component={TopAirlinesDeals} />
<Route path="/deals/last-minute-travel.html" component={LastMinuteTravel} />
<Route path="/deals/honeymoon-travel.html" component={HoneymoonTravel} />
<Route path="/deals/yoga-mediation-retreats.html" component={YogaMediationRetreats} />
<Route path="/deals/kids-travel.html" component={KidsTravel} />
<Route path="/deals/book-now-pay-later-flights.html" component={BookNowPayLaterFlights} />
<Route path="/deals/boxing-day-deals.html" component={BoxingDayDeals} />
<Route path="/deals/spring-break-deals.html" component={SpringBreakDeals} />
<Route path="/deals/sports-travel.html" component={SportsTravel} />
<Route path="/deals/red-eye-flights.html" component={RedEyeFlights} />
<Route path="/deals/mountain-travel.html" component={MountainTravel} />
<Route path="/deals/world-travel.html" component={WorldTravel} />
<Route path="/deals/nature-wildlife-travel.html" component={NatureWildlifeTravel} />
<Route path="/deals/non-stop-flights.html" component={NonStopFlights} />
<Route path="/deals/nightlife-travel.html" component={NightlifeTravel} />
<Route path="/deals/same-day-flights.html" component={SameDayFlights} />
<Route path="/deals/seasonal-travel.html" component={SeasonalTravel} />
<Route path="/deals/bereavement-fares.html" component={BereavementFares} />
<Route path="/deals/safari-travel.html" component={SafariTravel} />
<Route path="/deals/weekend-getaway.html" component={WeekendGetaway} />
<Route path="/deals/theme-park-travel.html" component={ThemeParkTravel} />
<Route path="/deals/ski-travel.html" component={SkiTravel} />

                         <Redirect from="*" to="/" />
                              </Switch>
                           
                       
                  <Footer />
                    </Router>
                </div> 
    );
}
export { App };
